const e=[`left`,`right`,`center`,`justify`,`inherit`];function t(t,n=`center`){return t&&e.includes(t)?t:n}export{t as getTextAlign};
//# sourceMappingURL=get-text-align.js.map